import { getNameLetters } from 'app/utils';
import { useAuth } from 'features/auth';
import React from 'react';
import { AvatarStyle } from './styles';

interface AvatarProps {
  letters?: string;
}

const Avatar = ({ letters: receivedLetters }: AvatarProps) => {
  const { fullName } = useAuth();

  let letters = receivedLetters || getNameLetters(fullName);

  return <AvatarStyle>{letters}</AvatarStyle>;
};

export default Avatar;
